module.exports = __webpack_public_path__ + "static/img/logo_en.288babd8.png";